















import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'
import ProjectPartners from '@/business/project/components/project-partners.vue'
import RespondecoCategories from '@/shared/components/respondeco-categories.vue'

@Component({
  name: 'project-header',
  components: { RespondecoCategories, ProjectPartners },
})
export default class ProjectHeader extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly project!: ProjectViewModel
}
